import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../../Context/AuthContext";
import { fetchWebserviceSummary } from "../api/webservice";
export const useFetchWebserviceSmry = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["fetchWebserviceSummary"],
    mutationFn: (data) => {
      return fetchWebserviceSummary({ data, token: user?.token });
    },
  });
};
